<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/admin/inventory'}">{{msg('库存管理')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('扫码入库')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-form label-width="100px">
            <el-tag style="font-size:15px; margin:5px 0px 5px 10px;" type="warning">
                提示：订单数量模式是将单号中的数量加入到对应的库存中；指定数量模式为在对应的库存加入指定的库存数量；
            </el-tag>
            <el-row :gutter="10" class="breadcrumb-wrap" style="padding-top:20px">
                <el-col :xs="12" :sm="12">
                    <el-form-item :label="msg('模式：')">
                        <el-checkbox v-model="checkedType1" @change="checBox1Change">订单数量</el-checkbox>
                        <el-checkbox v-model="checkedType2" @change="checBox2Change">指定数量</el-checkbox>
                        <el-input-number v-model="numType2" controls-position="right" :min="0" size="mini"></el-input-number>件
                        <el-checkbox v-model="locked">锁定</el-checkbox>
                    </el-form-item>
                    <el-form-item :label="msg('单号：')">
                        <el-input v-model="checkCode" ref="checkCodeRef" placeholder="请输入单号" size="medium" @keyup.native="autoCheckCode">
                            <el-checkbox slot="append" v-model="printed">打印架位标签</el-checkbox>
                        </el-input>
                    </el-form-item>
                    <el-button style="margin-left:10px;margin-top:10px;" type="success" size="mini" @click="clearTable">清空列表</el-button>
                </el-col>
            </el-row>
        </el-form> 
        <el-row :gutter="10"  class="ctrl-wrap" style="margin-left: 2px;margin-right: 2px;">
            <el-table :data="results" style="width: 80%;" max-height="400" size="mini" ref="dataTable" :key="tableKey" border stripe
             :default-sort = "{prop: 'index', order: 'descending'}"
            >
                <el-table-column prop="index" sortable :label="msg('序号')" width="80"></el-table-column>
                <el-table-column prop="code" sortable :label="msg('单号')" min-width="80"></el-table-column>
                <el-table-column prop="inStoreCode" sortable :label="msg('补货单号')" min-width="80"></el-table-column>
                <el-table-column prop="orderQty" sortable :label="msg('补货件数')" min-width="80"></el-table-column>
                <el-table-column prop="msg" :label="msg('结果')" min-width="120"></el-table-column>
            </el-table>

        </el-row>

        <div style="display:inline-block; width:1px; height:1px; overflow:hidden;">
            <audio controls="controls" preload ref="audioRef" >
            </audio>
        </div>

        <div style="text-align:center;" v-if="printed && tagDto">
            <vue-easy-print ref="easyPrint" tableShow>
                <template>
                    <div class="vw200" :key="index+'1'" style="text-align:center;">
                        <div style="padding-top:0px;font-size: 15px; font-weight:bold;  line-height:90%;">{{tagDto.shelfCode}}</div>
                        <img style="max-width:95%; padding-left:5px;" :src="tagDto.barcodeAsBase64"/>
                        <div style="font-size: 16px; line-height:90%;padding-top:1px;">{{tagDto.code}}</div>
                    </div>
                </template>
            </vue-easy-print>
        </div>

    </div>
</template>

<script>
import Warning from "../../assets/media/warning.wav";
import OkMp3 from "../../assets/media/ok.mp3"; //成功
import NoRecord from "../../assets/media/NoRecord.mp3";//订单编号不存在
import vueEasyPrint from "vue-easy-print";
export default {
  name: 'CheckCodeInStore',
    components: {
        vueEasyPrint: vueEasyPrint,
    },
  data(){
    return{
        checkCode:null,
        results:[], //返回结果
        tableKey:0,
        audioUrl:null,
        checkedType1:false,
        checkedType2:false,
        numType2:0,
        locked:false,
        printed:true,
        tagDto:null,
    }
    
  }, 
  mounted: function(){
        this.checkCode = null;
        this.results = [];
        this.tableKey = 0;
        this.$refs['checkCodeRef'].focus();
  },
  methods:{
    autoCheckCode(e){
        if(e.keyCode == 13){
            this.autoSubmit();
        }
    },
    playAudio(){
        let audio = this.$refs.audioRef;
        audio.src = this.audioUrl;
        audio.play();
    },
    checBox1Change(){
        if(this.checkedType1){
            this.checkedType2 = false;
        }
    },
    checBox2Change(){
        if(this.checkedType2){
            this.checkedType1 = false;
        }
    },
    clearTable(){
        this.results = [];
    },
    autoSubmit(){

        if(!this.checkedType1 && !this.checkedType2){
            this.$message(this.msg('请选择模式'));
            this.audioUrl = Warning;
            this.playAudio();
            return;
        }

        if(!this.checkCode){
            this.$message(this.msg('单号不能为空'));
            return;
        }

        if(this.checkedType2 && !this.numType2){
            this.audioUrl = Warning;
            this.playAudio();
            this.checkCode = null;
            this.$refs['checkCodeRef'].focus();
            return;
        }

        let type = null;
        if(this.checkedType1){
            type = 1;
        }else if(this.checkedType2){
            type = 2;
        }

        var _this = this;
        this.$axios.post(this.$kit.api.inventory.scanCodeInStore, 
            "code="+this.checkCode+"&type="+type
            +"&qty="+this.numType2+"&printed="+this.printed,
            {headers: {'Content-Type' : 'application/x-www-form-urlencoded'}}
        ).then((result) =>{

            if(result.status){
                _this.audioUrl = OkMp3;
            }else{
                if(result.msg == "单号不存在"){
                    _this.audioUrl = NoRecord;
                }else{
                    _this.audioUrl = Warning;
                }
            }
            _this.playAudio();
            
            let data = result.data;

            if(_this.checkedType2 && !_this.locked){
                _this.numType2 = 0;
            }
            if(_this.checkedType1){
                _this.locked = false;
                _this.numType2 = 0;
            }

            let index = this.results.length+1;
            data.index = index;
            _this.results.push(data);
            _this.checkCode = null;
            if(_this.printed && data.baseImg){
                _this.tagDto = {
                    shelfCode:data.shelfCode,
                    code:data.inStoreCode,
                    barcodeAsBase64:data.baseImg
                }
                _this.doPrint();
            }
        });
    },
    doPrint(){
        this.$nextTick(() => {
            setTimeout(()=>{
                this.$refs.easyPrint.print();
            }, 200);
        })
    },
  }
}
</script>

<style scoped lang="scss">
.tag-wrap {
  text-align: center;
  line-height: 1;
  font-size: 13px;
  color: #333;
}
.vw200{width:200px; margin:0px auto;}
</style>
